module.exports = __webpack_public_path__ + "images/banner-2-c61ef4d6abac1e7c7e8f267ca6a7b7b2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/Banner/banner-2.jpg
// module id = 23
// module chunks = 0